/**
 * Encode each segment of a site-root path so spaces and reserved characters
 * are safe in HTML `src` / `srcset` (srcset splits candidates on spaces).
 */
export function encodePublicPath(path: string): string {
  if (!path || !path.startsWith("/")) return path;
  return path
    .split("/")
    .map((seg) => (seg ? encodeURIComponent(seg) : ""))
    .join("/");
}
